// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import axios from "axios";
// import "./Banner.css";

// // ─── Custom Arrows ───────────────────────────────────────────
// const PrevArrow = ({ onClick }) => (
//   <div className="banner-arrow banner-prev" onClick={onClick}>
//     ❮
//   </div>
// );

// const NextArrow = ({ onClick }) => (
//   <div className="banner-arrow banner-next" onClick={onClick}>
//     ❯
//   </div>
// );

// // ─── Slider Settings ─────────────────────────────────────────
// const sliderSettings = {
//   dots: true,
//   infinite: true,
//   speed: 2900,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 4000,
//   arrows: true,
//   prevArrow: <PrevArrow />,
//   nextArrow: <NextArrow />,
// };

// // ─── Banner Component ─────────────────────────────────────────
// const Banner = () => {
//   const [bannerData, setBannerData] = useState([]);

//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_banner"
//         );
//         setBannerData(response.data.data);
//       } catch (error) {
//         console.error("Failed to fetch banners:", error);
//         // Fallback: show at least one slide even if API fails
//         setBannerData([{ banner_heading: "Banner" }]);
//       }
//     };

//     fetchBanners();
//   }, []);

//   return (
//     <div className="banner">
//       <Slider {...sliderSettings}>
//         {bannerData.map((banner, index) => (
//           <div key={index} className="banner-slide-wrapper">

//             {/* Banner Image */}
//             <img
//               src={`https://cyberathon.com/multivendor/${banner.banner_image}`}
//               alt={banner.banner_heading || "Banner"}
//               className="banner-img"
//             />

//             {/* Overlay Text — Left Side */}
//             <div className="banner-overlay-content">
//               <h1 className="banner-title">
//                 Curated Picks for <br></br>Your Lifestyle
//               </h1>
//               <p className="banner-subtext">
//                 Not everything. Only what matters.
//               </p>
//               <a href="#" className="banner-cta">
//                 Explore Now
//               </a>
//             </div>

//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default Banner;














// // 02-11-2026 static code
// import React, { useCallback, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import "./Banner.css";
// const BANNERS = [
//   {
//     src: "/img/bann.webp",
//     // src: "/images/banner1.jpg",
//     mobileSrc: "",
//     // mobileSrc: "/images/banner1-mobile.jpg",
//     alt: "Buy 1 Get 1 free",
//     link: "/products",
//   },
//   {
//     src: "/img/bann3.webp",
//     // src: "/images/banner2.jpg",
//     mobileSrc: "",
//     alt: "New arrivals",
//     link: "/products",
//   },
//   {
//     src: "/img/bann.webp",
//     // src: "/images/banner3.jpg",
//     mobileSrc: "",
//     alt: "Premium collection",
//     link: "/products",
//   },
//   {
//     src: "/img/bann3.webp",
//     // src: "/images/banner4.jpg",
//     mobileSrc: "",
//     alt: "Festive select",
//     link: "/products",
//   },
// ];

// /* Ek slide kitni der dikhegi (milliseconds). CSS mein bhi ring isi time mein poora hota hai. */
// const SLIDE_DURATION_MS = 5000;

// const Banner = () => {
//   const [current, setCurrent] = useState(0);
//   const touchStartX = useRef(null);

//   const goTo = useCallback((index) => {
//     setCurrent((index + BANNERS.length) % BANNERS.length);
//   }, []);

//   const goNext = useCallback(() => {
//     setCurrent((prev) => (prev + 1) % BANNERS.length);
//   }, []);

//   /* Swipe support (mobile) */
//   const onTouchStart = (e) => {
//     touchStartX.current = e.touches[0].clientX;
//   };

//   const onTouchEnd = (e) => {
//     if (touchStartX.current === null) return;
//     const diff = e.changedTouches[0].clientX - touchStartX.current;
//     touchStartX.current = null;
//     if (Math.abs(diff) < 50) return;
//     goTo(diff < 0 ? current + 1 : current - 1);
//   };

//   return (
//     <section
//       className="bannerChapter-root"
//       aria-roledescription="carousel"
//       aria-label="Featured banners"
//       onTouchStart={onTouchStart}
//       onTouchEnd={onTouchEnd}
//     >
//       {/* Slides */}
//       {BANNERS.map((banner, index) => {
//         const isActive = index === current;

//         return (
//           <Link
//             key={index}
//             to={banner.link}
//             className={`bannerChapter-slide ${isActive ? "bannerChapter-active" : ""}`}
//             aria-hidden={!isActive}
//             tabIndex={isActive ? 0 : -1}
//           >
//             <picture>
//               {banner.mobileSrc && (
//                 <source media="(max-width: 768px)" srcSet={banner.mobileSrc} />
//               )}
//               <img
//                 src={banner.src}
//                 alt={banner.alt}
//                 className="bannerChapter-img"
//                 loading={index === 0 ? "eager" : "lazy"}
//                 draggable={false}
//               />
//             </picture>
//           </Link>
//         );
//       })}

//       {/* Dots with circular loader (bottom right) */}
//       <div className="bannerChapter-dots" role="tablist" aria-label="Choose banner">
//         {BANNERS.map((banner, index) => {
//           const isActive = index === current;

//           return (
//             <button
//               key={index}
//               type="button"
//               role="tab"
//               aria-selected={isActive}
//               aria-label={`Show banner ${index + 1}`}
//               className={`bannerChapter-dot ${isActive ? "bannerChapter-dot-active" : ""}`}
//               onClick={() => goTo(index)}
//             >
//               <span className="bannerChapter-dot-core" />

//               {isActive && (
//                 <svg className="bannerChapter-ring" viewBox="0 0 20 20" aria-hidden="true">
//                   <circle className="bannerChapter-ring-track" cx="10" cy="10" r="8" />
//                   {/* key=current -> har naye slide par animation dobara shuru */}
//                   <circle
//                     key={current}
//                     className="bannerChapter-ring-progress"
//                     cx="10"
//                     cy="10"
//                     r="8"
//                     style={{ animationDuration: `${SLIDE_DURATION_MS}ms` }}
//                     onAnimationEnd={goNext}
//                   />
//                 </svg>
//               )}
//             </button>
//           );
//         })}
//       </div>
//     </section>
//   );
// };

// export default Banner;








// 04-11-2026 Dyanamic code
// Dynamic Banner (API based)
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Banner.css";

/* API endpoint */
const BANNER_API =
  "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_banner";

/* Fallback agar API fail ho ya list khali ho (optional, chaaho to hata do) */
const FALLBACK_BANNERS = [];

/* Ek slide kitni der dikhegi (milliseconds). CSS mein bhi ring isi time mein poora hota hai. */
const SLIDE_DURATION_MS = 5000;

/* API response ko banners array mein badalta hai, id ascending order mein */
const normalizeBanners = (json) => {
  const raw = json?.data;
  if (!raw) return [];

  const list = Array.isArray(raw) ? raw : [raw];

  return list
    .filter((item) => item && item.banner_url)
    .sort((a, b) => Number(a.id) - Number(b.id)) // pehle add hua -> pehle dikhe
    .map((item) => ({
      id: item.id,
      src: item.banner_url,
      mobileSrc: item.mobile_banner_url || "", // agar API future mein deti hai
      alt: item.title || item.alt || `Banner ${item.id}`,
      link: item.link || "/products",
    }));
};

const Banner = () => {
  const [banners, setBanners] = useState(FALLBACK_BANNERS);
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(null);

  /* API call */
  useEffect(() => {
    const controller = new AbortController();

    const loadBanners = async () => {
      try {
        const res = await fetch(BANNER_API, { signal: controller.signal });
        const json = await res.json();
        const list = normalizeBanners(json);
        if (list.length) {
          setBanners(list);
          setCurrent(0);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Banner API error:", err);
        }
      }
    };

    loadBanners();
    return () => controller.abort();
  }, []);

  const total = banners.length;

  const goTo = useCallback(
    (index) => {
      if (!total) return;
      setCurrent((index + total) % total);
    },
    [total]
  );

  const goNext = useCallback(() => {
    if (!total) return;
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  /* Swipe support (mobile) */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = e.changedTouches[0].clientX - touchStartX.current;
    touchStartX.current = null;
    if (Math.abs(diff) < 50) return;
    goTo(diff < 0 ? current + 1 : current - 1);
  };

  /* Jab tak banners nahi aate kuch render mat karo */
  if (!total) return null;

  return (
    <section
      className="bannerChapter-root"
      aria-roledescription="carousel"
      aria-label="Featured banners"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {/* Slides */}
      {banners.map((banner, index) => {
        const isActive = index === current;

        return (
          // <Link
          //   key={banner.id ?? index}
          //   to={banner.link}
          //   className={`bannerChapter-slide ${isActive ? "bannerChapter-active" : ""}`}
          //   aria-hidden={!isActive}
          //   tabIndex={isActive ? 0 : -1}
          // >
          //   <picture>
          //     {banner.mobileSrc && (
          //       <source media="(max-width: 768px)" srcSet={banner.mobileSrc} />
          //     )}
          //     <img
          //       src={banner.src}
          //       alt={banner.alt}
          //       className="bannerChapter-img"
          //       loading={index === 0 ? "eager" : "lazy"}
          //       draggable={false}
          //     />
          //   </picture>
          // </Link>
          <div
  key={banner.id ?? index}
  className={`bannerChapter-slide ${isActive ? "bannerChapter-active" : ""}`}
  aria-hidden={!isActive}
>
  <picture>
    {banner.mobileSrc && (
      <source media="(max-width: 768px)" srcSet={banner.mobileSrc} />
    )}
    <img
      src={banner.src}
      alt={banner.alt}
      className="bannerChapter-img"
      loading={index === 0 ? "eager" : "lazy"}
      draggable={false}
    />
  </picture>
</div>
        );
      })}

      {/* Dots with circular loader (bottom right) */}
      <div className="bannerChapter-dots" role="tablist" aria-label="Choose banner">
        {banners.map((banner, index) => {
          const isActive = index === current;

          return (
            <button
              key={banner.id ?? index}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-label={`Show banner ${index + 1}`}
              className={`bannerChapter-dot ${isActive ? "bannerChapter-dot-active" : ""}`}
              onClick={() => goTo(index)}
            >
              <span className="bannerChapter-dot-core" />

              {isActive && (
                <svg className="bannerChapter-ring" viewBox="0 0 20 20" aria-hidden="true">
                  <circle className="bannerChapter-ring-track" cx="10" cy="10" r="8" />
                  {/* key=current -> har naye slide par animation dobara shuru */}
                  <circle
                    key={current}
                    className="bannerChapter-ring-progress"
                    cx="10"
                    cy="10"
                    r="8"
                    style={{ animationDuration: `${SLIDE_DURATION_MS}ms` }}
                    onAnimationEnd={goNext}
                  />
                </svg>
              )}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default Banner;